export default __webpack_public_path__ + "static/SRUS SP55 - Product Specifications & Technical Data-56f7d0a7a4eda313311389382bafe17e.pdf";